var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"appXBox text-h6 leading-none"},[(_vm.active)?_c('i',{staticClass:"fas fa-times-square text-danger"}):_c('i',{staticClass:"fal fa-square text-gray-900"})])}
var staticRenderFns = []

export { render, staticRenderFns }